module.exports = __webpack_public_path__ + "img/Market Explorer.6ae483df.svg";